<template>
  <div>
    <div v-if="addressStakes.length > 0">
      <b-table
        :data="addressStakes"
        class="table"
	    v-bind:mobileCards="false"
      >
        <template slot-scope="props">

          <b-table-column field="validator" label="Validator">
            <router-link
              class="router-link short-addr"
              :to="{ name: 'address', params: {address: props.row.validator}}"
            >
              {{ props.row.validator }}
            </router-link>
          </b-table-column>

          <b-table-column field="cmtType" label="CMT Type">
            {{ props.row.cmtType}}
          </b-table-column>

          <b-table-column field="amount" label="Amount">
            {{ props.row.amount }}
          </b-table-column>

          <b-table-column field="timeStamp" label="Timestamp">
            <v-tooltip v-if="props.row.timestamp" bottom>
                <span slot="activator">
                    <timeago
                      :datetime="props.row.timestamp"
                      :auto-update="10">
                    </timeago>
                </span>
                <span>{{ new Date(props.row.timestamp).toISOString() }}</span>
              </v-tooltip>
          </b-table-column>

        </template>
      </b-table>
    </div>
      <Empty v-else/>
      <el-pagination
        small
        background
        :current-page="current_page"
        @current-change="shift"
        @prev-click="shift(current_page-1)"
        @next-click="shift(current_page+1)"
        layout="prev, pager, next"
        :current_page.sync="current_page"
        :pager-count=5
        :page-size="pageSize"
        :total="totalAddressStakes">
      </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Empty from '../reusables/empty.vue';

export default {
  name: 'AddressStakes',
  props: ['address', 'isContract'],
  components: {
    Empty,
  },
  computed: {
    ...mapGetters(['addressStakes', 'totalAddressStakes']),
  },
  data() {
    return {
      current_page: 1,
      pageSize: 10,
    };
  },
  watch: {
    '$route.params.address': function () {
      this.shift(1);
    },
  },
  methods: {
    shift(page) {
      this.$store.dispatch('fetchAddressStakes', {
        address: this.address,
        limit: this.pageSize,
        page,
      });
      this.current_page = page;
    },
  },
  created() {
    this.shift(1);
  },
};
</script>
